import classNames from "classnames";
import { FocusBoundary } from "keyboardNavigation/FocusBoundary";
import React, { type ReactNode } from "react";
import { type PopupProps } from "semantic-ui-react";
import { useEffectNotOnMount } from "utilities/hookutils";
import PopperTooltip from "./PopperTooltip";

interface Props {
  position: PopupProps["position"]

  startOpen?: boolean

  open?: boolean
  onOpen: (() => Promise<any>) | (() => any)
  onClose?: () => void

  trigger?: ReactNode
  tooltipStyle?: React.CSSProperties
  tooltipClasses?: string

  width?: number

  children: ((close: () => void) => React.ReactNode) | React.ReactNode
}

const TooltipBase = (props: Props) => {
  const [tooltipVisible, setTooltipVisible] = React.useState(props.startOpen ?? false);
  const [transitioning, setTransitioning] = React.useState<"fade in" | "fade out" | "">("");
  const triggerRef = React.useRef();

  const onOpen = async () => {
    await props.onOpen();

    setTransitioning("fade in");
    setTooltipVisible(true);
  };

  const onClose = () => {
    // @ts-expect-error - Typing is not correct in Semantic UI Portal
    triggerRef?.current?.focus();

    setTransitioning("fade out");
    setTimeout(() => {
      setTooltipVisible(false);
      props.onClose?.();
    }, 100);
  };

  useEffectNotOnMount(() => {
    if (props.open) {
      onOpen();
    } else {
      onClose();
    }
  }, [props.open]);

  const classes = classNames(
    // "appointment-tooltip",
    props.tooltipClasses,
    transitioning
  );

  return <PopperTooltip
    position={props.position}
    triggerRef={triggerRef}
    onOpen={onOpen}
    onClose={onClose}
    react={{
      open: tooltipVisible,
      trigger: props.trigger
    }}
    width={props.width}
    classes={classes}
    style={props.tooltipStyle}
  >
    <FocusBoundary>
      {typeof props.children === "function" ? props.children(onClose) : props.children}
    </FocusBoundary>
  </PopperTooltip>;
};

export default TooltipBase;